import React, { useEffect, useRef, useState } from 'react';
import { CONTENT, TABS } from './StorageUnitSizeContent';
import './StorageUnitSizeModal.scss';

export default function StorageUnitSizeModal() {
	const [active, setActive] = useState('Wine');
	const wrapperRef = useRef(null);
	const tabRefs = useRef({});

	useEffect(() => {
		const wrapper = wrapperRef.current;
		const btn = tabRefs.current[active];
		if (!wrapper || !btn) return;

		const wrapperRect = wrapper.getBoundingClientRect();
		const btnRect = btn.getBoundingClientRect();
		const centerX =
			btnRect.left + btnRect.width / 2 - wrapperRect.left - 20;

		wrapper.style.setProperty('--triangle-x', `${centerX}px`);
	}, [active]);

	const data = CONTENT[active] || {
		title: `${active} Storage Unit`,
		sqft: 'Details coming soon',
	};

	return (
		<div
			className="unit-size-guide"
			ref={wrapperRef}
		>
			<div className="unit-size-guide__tabs">
				{TABS.map((tab) => (
					<button
						key={tab}
						ref={(el) => (tabRefs.current[tab] = el)}
						className={`unit-size-guide__tab ${
							active === tab ? 'is-active' : ''
						}`}
						onClick={() => setActive(tab)}
					>
						{tab}
					</button>
				))}
			</div>
			<div className="unit-size-guide__triangle"> </div>
			<div className="unit-size-guide__content">
				<h2 className="size_title">{data.title}</h2>
				<div className="size_info">
					{[
						{
							label: 'Square Footage',
							value: data.sqft,
							always: true,
						},
						{ label: 'Looks Like:', value: data.looksLike },
						{ label: 'What Will Fit:', value: data.whatWillFit },
					]
						.filter((item) => item.always || item.value)
						.map(({ label, value }) => (
							<div
								className="size_row"
								key={label}
							>
								<strong className="size_label">{label}</strong>
								<span className="size_value">{value}</span>
							</div>
						))}
				</div>
			</div>
		</div>
	);
}
